import { Record } from "immutable";

const defaults = {
    __name: undefined,
};

export class GenericFilterRecord extends Record(defaults) {
    declare __name: string;
}

export default GenericFilterRecord;
